import tw from 'tailwind.macro';
import React from 'react';
import styled from 'styled-components';
import Content from './Content';
import Description from './Description';
import Social from './Social';
import LandingHeading from './LandingHeading';

import profileImage from '../profile.png';

const Intro = styled(Content)`
  ${tw`py-8 md:py-16`};
`;

const Title = styled.h1`
  ${tw`text-3xl md:text-5xl`};
  span {
    ${tw`text-orange`};
  }
`;

const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
  align-items: center;
  background-color: #3f3f3f;
`;

const FlexChild = styled.div`
  flex: 50%;
`;

const FlexChildImg = styled.div`
  flex: 50%;
  text-align: center;
`;

const ProfileImg = styled.img`
  border-radius: 50%;
  max-width: 25vw;
  @media (max-width: 900px) {
    max-width: 256px;
  }
`;

const Header = () => (
  <>
    <FlexContainer>
      <LandingHeading />
    </FlexContainer>
    <Intro>
      <Title>
        Hello there<span>,</span> visitor
        <span>.</span>
      </Title>
      <Description>
        <p>
          I'm a <i>Software Engineer</i> with a proficiency in{' '}
          <i>
            web application design and engineering
            <span>.</span>
          </i>
          <br />
          If you're looking for an <i>autonomous creative developer</i> to help
          build impactful, human-centric products<span>,</span> let's talk
          <span>!</span>
          <br />
          <br />
          When I'm not tinkering with code or pushing pixels<span>,</span> I'm
          mostly thinking of my next big plan to take over the world{' '}
          <span>:)</span>
        </p>
      </Description>
      <Social />
    </Intro>
  </>
);

export default Header;
